import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LOW_RISK, MEDIUM_RISK, STATUS } from '../../enums/common'
import { IBreadCrumb, IBreadcrumbSlice } from '../../interfaces/Breadcrumb'
import {
  folderSaved,
  initialDataFailed,
  initialDataLoading,
  initialDataReceived,
} from '../actions'
import { setLoading } from '../reducers'
import { activeStep, getUpdatedBreadcrumb } from '../../services/utils'

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState: {
    status: STATUS.idle,
    breadcrumb: [] as IBreadCrumb[],
    step: 0,
  } as IBreadcrumbSlice,
  reducers: {
    breadcrumbLoading: setLoading,
    breadcrumbReceived: (
      state: IBreadcrumbSlice,
      action: PayloadAction<IBreadCrumb[]>
    ) => {
      if (state.status === STATUS.pending) {
        return {
          ...state,
          breadcrumb: action.payload,
          status: STATUS.loaded,
        }
      }

      return state
    },
    breadcrumbLoaded: (state) => ({ ...state, status: STATUS.loaded }),
    changeStep: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        step: action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initialDataReceived, (state, action) => {
        if (state.status === STATUS.pending) {
          return {
            ...state,
            breadcrumb: getUpdatedBreadcrumb(
              action.payload[1],
              [MEDIUM_RISK, LOW_RISK].includes(action.payload[0].score_secu_fin)
            ),
            status: STATUS.loaded,
            step: activeStep(
              action.payload[1],
              action.payload[0].journeyStatus
            ),
          }
        }

        return state
      })
      .addCase(initialDataLoading, setLoading)
      .addCase(initialDataFailed, (state) => {
        if (state.status === STATUS.pending) {
          return { ...state, status: STATUS.failed }
        }

        return state
      })
      .addCase(folderSaved, (state, action) => {
        if (state.status === STATUS.pending) {
          return {
            ...state,
            step: action.payload.next_step,
            status: STATUS.loaded,
          }
        }

        return state
      })
  },
})

const { actions, reducer } = breadcrumbSlice
export const breadcrumbActions = actions

export default reducer
